import { PropertyLookupDetail } from '../../shared/models/property-lookup-detail';
import { FormGroup } from '@angular/forms';
import { PropertyLookupStore } from '../../shared/lookup/property-lookup/property-lookup.store';

export class PropertyLookupConverter {

  static updateFormFields(detail: PropertyLookupDetail,
                          contactLookupForm: FormGroup,
                          propertyLookupStore: PropertyLookupStore) {

    contactLookupForm.patchValue({
      name: detail.name,
      line1: detail.address.line1,
      line2: detail.address.line2,
      city: detail.address.city,
      state: detail.address.state,
      postalCode: detail.address.postalCode,
      propertyId: detail.propertyId,
      chain: detail.chain,
      brand: detail.brand
    });
    contactLookupForm.controls[ 'contact' ].patchValue({
      firstName: detail.contact.firstName,
      lastName: detail.contact.lastName,
      email: detail.contact.email,
      phone: detail.contact.phone,
      fax: detail.contact.fax
    });


    contactLookupForm.controls[ 'propertyNameSearch' ].setValue('');
    propertyLookupStore.clearSearchResults();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/property-lookup-converter.ts